import type { QueryClient } from '@tanstack/react-query'
import type { NotificationPrefsOut, SessionStatus } from '../../lib/api/generated'
import { sessionQuery } from '../../lib/api/queries'

/** Keep the preference and signed-in session views coherent before the invalidated API reads return. */
export function rememberBrandScope(queryClient: QueryClient, brandScope: string, saved: NotificationPrefsOut): void {
  queryClient.setQueryData<NotificationPrefsOut>(['me', 'notifications'], (current) => ({
    ...current,
    ...saved,
    brand_scope: brandScope,
  }))
  queryClient.setQueryData<SessionStatus>(sessionQuery().queryKey, (current) => {
    if (!current?.me) return current
    return { ...current, me: { ...current.me, brand_scope: brandScope } }
  })
}

export function refreshBrandScopedQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ['queue'] })
  void queryClient.invalidateQueries({ queryKey: ['search'] })
}
